const awsExports = {
    aws_project_region: 'us-east-1', // tu región
    aws_cognito_region: 'us-east-1', // tu región
    aws_user_pools_id: 'us-east-1_xiQEqkQ8G', // tu User Pool ID
    aws_user_pools_web_client_id: 'chs13tsavvl8gaeq1bhj8efmj', // tu App Client ID
    oauth: {
      domain: 'siimed.auth.us-east-1.amazoncognito.com', // tu Hosted UI domain
      scope: ['openid', 'email', 'profile'],
      //redirectSignIn: 'http://localhost:3000/',
      //redirectSignOut: 'http://localhost:3000/',
      redirectSignIn: 'https://portal.siimed.com.co/',
      redirectSignOut: 'https://portal.siimed.com.co/',
      responseType: 'token', // usamos implicit grant
    }
  };
  
  export default awsExports;
  